import React from 'react';
import { Breadcrumb } from 'ui/common/breadcrumb/breadcrumb';

import { ComplexValue } from 'app/types-shared';
import { routeConstants } from 'app/routes/route-constants';
import { buildGoBackBreadcrumbs } from 'app/area/shared/codetable/breadcrumbs';
import { CodetableItemLoader } from 'app/area/shared/codetable/item/codetable-item-loader';
import { to, toCodeSelectView } from 'app/area/shared/navigation';

import { LinkCodesTranslation } from '../constants';
import { 
  useBreadcrumbsSelectors, useLoadBreadcrumbsEffect, useLoadCodetablesAccessEffect, 
  useLoadMetadataEffect 
} from '../hooks';

import styles from './link-codes-header.scss';
import { hasTranslationsLoaded } from 'app/infrastructure/translate/selectors';

interface LinkCodesHeaderProps {
  breadcrumbs: number[];
  linkSubset: boolean;
  translation: LinkCodesTranslation;
}

export const LinkCodesHeader: React.FC<LinkCodesHeaderProps> = ({
  breadcrumbs, linkSubset, translation
}) => {

  if (!hasTranslationsLoaded(translation)) {
    return null;
  }

  useLoadBreadcrumbsEffect(breadcrumbs, linkSubset);
  useLoadMetadataEffect();
  useLoadCodetablesAccessEffect();

  const { fetchingBreadcrumbs, breadcrumbsOptions } = useBreadcrumbsSelectors();

  const shouldRenderBreadcrumbs = !fetchingBreadcrumbs && !!breadcrumbs?.length;

  const goBackToCodeSelector = (item: ComplexValue<number>) =>
    toCodeSelectView(buildGoBackBreadcrumbs(item, breadcrumbs));

  const goBackToHomeCodeSelector = () => to(routeConstants.selectCodetableAdministration);

  return <div className={`${styles.breadcrumbRow} row`}>
    {fetchingBreadcrumbs ? <CodetableItemLoader /> : null}
    {shouldRenderBreadcrumbs
      ? <Breadcrumb
        items={breadcrumbsOptions ?? []}
        home={true}
        homeLabel={translation.codetable_administration}
        onClickItem={goBackToCodeSelector}
        onClickBreadcrumbHome={goBackToHomeCodeSelector} />
      : <div className={styles.breadcrumbPlaceholder} />}
  </div>;
};
